var map = {
	"./2fa_border.svg": "c68f",
	"./bank_account_border.svg": "0a4f",
	"./bank_accounts_border.svg": "c1bf",
	"./change_password_border.svg": "deb5",
	"./change_pin_border.svg": "39ef",
	"./documents_border.svg": "8758",
	"./email_notifications_border.svg": "56a8",
	"./face_id_border.svg": "ffbd",
	"./faqs_border.svg": "d7b5",
	"./fiscal_information_border.svg": "03f4",
	"./language_border.svg": "2760",
	"./legal_representative_border.svg": "7526",
	"./logout_border.svg": "fa9b",
	"./organizations_details_border.svg": "8ac3",
	"./personal_details_border.svg": "4557",
	"./privacy_policy_border.svg": "a44f",
	"./suitability_border.svg": "1987",
	"./terms_and_conditions_border.svg": "8e7a",
	"./wallets_border.svg": "b3a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd9d0";